import React from 'react';

import Popup from '../../Popup';
import { capitalize } from '../../../utils/formatting';

import styles from './confirmActionPopup.scss';

const ConfirmActionPopup = props => {
    const {
        onCloseClick,
        onCtaClick,
        confirmationTitle = 'Confirmation',
        confirmationMessage = 'Are you sure?',
        confirmationDataValue,
        confirmButtonLabel = 'Yes',
        disabled = false,
        'data-testid': dataTestId,
    } = props;

    return (
        <Popup
            className={`popup-sm`}
            popUpClassName={`${styles.confirmActionPopup}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
                noHeader: true,
                showCloseIcon: false,
            }}
        >
            <div className={`${styles.section} pt24`}>
                <div className={`${styles.title} text-dark`} data-testid={dataTestId && `${dataTestId}.title`}>
                    {capitalize(confirmationTitle)}
                </div>
            </div>
            <div className={` ${styles.confirmationMessage} ${styles.section} pt0`}>
                <div className="row">
                    <div className="col-12">
                        <p data-testid={dataTestId && `${dataTestId}.message`}>{confirmationMessage}</p>
                    </div>
                </div>
                <div className="row">
                    <div className={`${styles.cancelBtn} col-md-6 mb8`}>
                        <button
                            onClick={onCloseClick}
                            type="button"
                            className={`btn btn-default btn-sm text-uppercase btn-block`}
                            data-testid={dataTestId && `${dataTestId}.cancel-btn`}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className={`${styles.confirmBtn} col-md-6 mb8 `}>
                        <button
                            onClick={(ev) => {
                                onCtaClick(ev, confirmationDataValue);
                            }}
                            type="button"
                            className={`btn btn-primary btn-sm text-uppercase btn-block`}
                            disabled={disabled}
                            data-testid={dataTestId && `${dataTestId}.confirm-btn`}
                        >
                            {confirmButtonLabel}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

ConfirmActionPopup.defaultProps = {
    'data-testid': null,
};

export default ConfirmActionPopup;
